export default __webpack_public_path__ + "static/media/RichMerge.3380e410.png";